module.exports = __webpack_public_path__ + "img/logo.a59c2257.png";